import { initializeElmahIo } from './logging/elmahIo';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './main/App';
import * as serviceWorker from './serviceWorker';
import 'react-app-polyfill/ie11';
import { ElmahErrorBoundary } from './logging/ElmahErrorBoundary';

// Before ReactDOM.render — https://docs.elmah.io/logging-to-elmah-io-from-react/
initializeElmahIo();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <ElmahErrorBoundary>
      <App />
    </ElmahErrorBoundary>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
